// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"
import littlefoot from 'littlefoot'
import 'littlefoot/dist/littlefoot.css'

export function onRouteUpdate() {
  littlefoot() // Pass any littlefoot settings here.
}
